import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  computed,
  input,
  output,
} from '@angular/core';

import { FnBindPipe } from '@recruitee/common';
import type { Placement } from '@recruitee/placements-types';
import type { Stage } from '@recruitee/stages-types';
import { StageCategory, StageGroup } from '@recruitee/stages-types';
import {
  ButtonComponent,
  ButtonDropdownIndicatorDirective,
  ConnectedOverlayDirective,
  IconComponent,
  OverlayOriginDirective,
  TruncateComponent,
} from '@recruitee/user-interface';
import { WalkthroughStepOriginDirective } from '@recruitee/walkthrough';

import type {
  PlacementActions,
  ProceedEvent,
  ShowAutomatedActionDetailsEvent,
} from '../../candidate-profile-placements/types';
import { CandidateStageMenuComponent } from '../../candidate-stage-menu/candidate-stage.menu.component';
import { StagesWithProgressService } from '../../candidate-stage-menu/stages-with-progress.service';

@Component({
  selector: 'rt-stage-select',
  templateUrl: './stage-select.component.html',
  styleUrls: ['./stage-select.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ButtonComponent,
    IconComponent,
    TruncateComponent,
    CandidateStageMenuComponent,
    ConnectedOverlayDirective,
    OverlayOriginDirective,
    ButtonDropdownIndicatorDirective,
    WalkthroughStepOriginDirective,
    FnBindPipe,
  ],
})
export class StageSelectComponent {
  public placement = input.required<Placement>();

  public stages = input.required<Stage[]>();

  public placementActions = input.required<PlacementActions>();

  public stage = computed(() => this.placement().stage);

  public stagesWithProgress = computed(() => {
    const visibleStages = this.stages().filter(
      stage => !stage.locked || (stage.locked && stage.category === StageCategory.Apply),
    );
    return this.stagesWithProgressService.get(
      visibleStages,
      this.placement(),
      this.placementActions().proceed,
      this.placementActions().hire,
    );
  });

  public StageGroup = StageGroup;

  public proceedClick = output<ProceedEvent>();

  public showAutomatedActionDetailsClick = output<ShowAutomatedActionDetailsEvent>();

  constructor(
    private stagesWithProgressService: StagesWithProgressService,
    private cdRef: ChangeDetectorRef,
  ) {}

  public toggleDropdown(stageDropdown: ConnectedOverlayDirective) {
    stageDropdown.open = !stageDropdown.open;
    this.cdRef.detectChanges();
  }

  public beforeWalkthroughTooltipRender(dialog: ConnectedOverlayDirective) {
    this.toggleDropdown(dialog);
  }

  public afterWalkthroughTooltipDispose(dialog: ConnectedOverlayDirective) {
    this.toggleDropdown(dialog);
  }
}
